<div class="number">{{ number }}</div>
<div class="panel">
  <div class="title" *ngIf="title">{{ title }}</div>
  <ng-content></ng-content>
</div>
